import { connect } from "react-redux"
import React, { Component } from "react"

import type { Evidence, Role } from "../../types/types"
import { evidenceListRequest } from "../../actions/evidence-actions"
import ContentLoaderLines from "./content-loading/ContentLoaderLines"
import EvidenceListItem from "./EvidenceListItem"
import TagItem from "./tags/TagItem"
import Tags from "./tags/Tags"

type Props = {
    role: Role,
    isFetching: boolean,
    evidence: Array<Evidence>,
    getEvidence: string => void
}

type State = {
    isExpanded: boolean
}

class StakeholderRelationshipViewRoleBlock extends Component<Props, State> {
    state = {
        isExpanded: false
    }

    toggle = () => {
        if (!this.state.isExpanded) {
            this.props.getEvidence(this.props.role.id)
        }

        this.setState({
            isExpanded: !this.state.isExpanded
        })
    }

    render() {
        const { role, isFetching, evidence } = this.props

        const { isExpanded } = this.state

        let contentElements

        if (evidence && evidence.length > 0) {
            contentElements = evidence.map((item, index) => (
                <EvidenceListItem key={item.id || index} item={item} />
            ))
        } else {
            contentElements = (
                <p className="stakeholder-no-evidence">No evidence added yet</p>
            )
        }

        return (
            <div className="stakeholder-role-container" onClick={this.toggle}>
                <div
                    className={`stakeholder-role-block ${isExpanded
                        ? "stakeholder-role-block--expanded"
                        : ""}`}
                    data-cy="relationshipTypeViewMode"
                >
                    <div className="stakeholder-role-name">{role.name}</div>
                    <Tags isSpan={true}>
                        <TagItem isGrey={true} className="stakeholder-tag-item">
                            {role.linked_node.name}
                        </TagItem>
                    </Tags>
                    <span
                        className={`fa fa-chevron-${isExpanded
                            ? "up"
                            : "down"} stakeholder-role-toggle`}
                    />
                </div>
                {isExpanded && (
                    <ContentLoaderLines
                        className="stakeholder-role-loader-lines"
                        isFetching={isFetching}
                        minLines={1}
                        maxLines={2}
                    >
                        {contentElements}
                    </ContentLoaderLines>
                )}
            </div>
        )
    }
}

const mapStateToProps = ({ presentation }, { role }) => ({
    isFetching: presentation.evidence[role.id].isFetchingList,
    evidence: presentation.evidence[role.id].view
})

const mapDispatchToProps = dispatch => ({
    getEvidence: roleID => dispatch(evidenceListRequest(roleID))
})

export default connect(mapStateToProps, mapDispatchToProps)(
    StakeholderRelationshipViewRoleBlock
)
